import { Tag } from "../../common/video/models/VideoFilter";
import { FilePreviewImage, TempFile } from "../../models/slides";
import { AppAction } from "../../root/AppAction";
import SlideEvent from "../events/SlideEvent";
import { Slide } from "../../models/slides";

export interface SlideStore {
    userUploadFile: File | null;
    userUploadUrl: string;
    contents: { [id: number]: Slide };
    tags: Tag[];
    tempFile: TempFile;
    tempFilePreviewImage: FilePreviewImage[];
    tempFilePageCount: number;
    slidePageCount: number;
    slidePreviewImageUrl: FilePreviewImage[];
    isLoading: boolean;
    slide: Slide | undefined;
    isCreateNewSlideComplete: boolean;
    isSuccessGetTempFilePageCount: boolean;
    isLoadingGetTempFilePageCount: boolean;
    isEditSlide: boolean;
    isSuccessEditSlide: boolean;
    isFailedEditSlide: boolean;
    isDeleteSlide: boolean;
    isSuccessDeleteSlide: boolean;
    isFailedDeleteSlide: boolean;
}

const initialSlideStore: SlideStore = {
    userUploadFile: null,
    userUploadUrl: "",
    contents: {},
    tags: [],
    tempFile: { keyName: "", fileName: "", url: "" },
    tempFilePreviewImage: [],
    tempFilePageCount: 0,
    slidePageCount: 0,
    slidePreviewImageUrl: [],
    isLoading: false,
    slide: undefined,
    isCreateNewSlideComplete: false,
    isSuccessGetTempFilePageCount: false,
    isLoadingGetTempFilePageCount: false,
    isEditSlide: false,
    isSuccessEditSlide: false,
    isFailedEditSlide: false,
    isDeleteSlide: false,
    isSuccessDeleteSlide: false,
    isFailedDeleteSlide: false,
};

export function slide(state: SlideStore = initialSlideStore, action: AppAction) {
    switch (action.type) {
        // コンテンツアップロードでURL生成
        case SlideEvent.CreateTempFileStarted:
            return {
                ...state,
                tempFile: { keyName: "", fileName: "", url: "" },
                tempFilePreviewImage: [],
                tempFilePageCount: 0,
                isSuccessGetTempFilePageCount: true,
            };

        case SlideEvent.CreateTempFileComplete:
            return {
                ...state,
                tempFile: action.tempFile,
                userUploadUrl: "",
                isLoading: false,
            };

        // tempファイルのページ総数の取得
        case SlideEvent.GetTempPageCountStarted:
            return {
                ...state,
                tempFilePageCount: 0,
                tempFilePreviewImage: [],
                isSuccessGetTempFilePageCount: false,
                isLoadingGetTempFilePageCount: true,
            };

        case SlideEvent.GetTempPageCountComplete:
            return {
                ...state,
                tempFilePageCount: action.pageCount,
                isSuccessGetTempFilePageCount: true,
                isLoadingGetTempFilePageCount: action.pageCount === 0 ? true : false,
            };

        // tempファイル表示URLの取得
        case SlideEvent.GetTempPreviewUrlStarted:
            return {
                ...state,
                isLoading: true,
            };

        case SlideEvent.GetTempPreviewUrlComplete:
            return {
                ...state,
                tempFilePreviewImage: [...state.tempFilePreviewImage, action.previewImage],
                isFailedGetTempFileImage: false,
                isLoading: false,
            };

        // 新規コンテンツ作成
        case SlideEvent.CreateNewSlideComplete:
            return {
                ...state,
                userUploadUrl: "",
                userUploadFile: null,
                tempFile: { keyName: "", fileName: "", url: "" },
                tempFilePreviewImage: [],
                tempFilePageCount: 0,
                isCreateNewSlideComplete: true,
            };

        // 新規コンテンツ作成キャンセルでtempファイルの削除
        case SlideEvent.DeleteTempFileComplete:
            if (action.keyName === state.tempFile.keyName) {
                return {
                    ...state,
                    userUploadFile: null,
                    tempFile: { keyName: "", fileName: "", url: "" },
                    tempFilePageCount: 0,
                };
            } else {
                return {
                    ...state,
                    tempFilePageCount: 0,
                };
            }

        // コンテンツ情報取得
        case SlideEvent.GetSlideByIdStarted:
            return {
                ...state,
                slide: undefined,
            };

        case SlideEvent.GetSlideByIdComplete:
            return {
                ...state,
                slide: action.slide,
            };

        // コンテンツページ総数の取得
        case SlideEvent.GetSlidePageCountStarted:
            return {
                ...state,
                podFilePageCount: 0,
            };

        case SlideEvent.GetSlidePageCountComplete:
            return {
                ...state,
                slidePageCount: action.pageCount,
            };

        // コンテンツ表示URLの取得
        case SlideEvent.GetSlidePreviewImageUrlComplete:
            return {
                ...state,
                slidePreviewImageUrl: [...state.slidePreviewImageUrl, action.previewImage],
            };

        // コンテンツのコメント
        case SlideEvent.AddSlideCommentComplete:
            return {
                ...state,
                slide: {
                    ...state.slide,
                    comments: action.comment
                },
            };

        // コメントの更新
        case SlideEvent.UpdateSlideCommentComplete:
            return {
                ...state,
                slide: {
                    ...state.slide,
                    comments: action.slideCommentChangeSet
                },
            };

        // コメントの削除
        case SlideEvent.DeleteSlideCommentComplete:
            return {
                ...state,
                slide: {
                    ...state.slide,
                    comments: action.slideCommentChangeSet
                },
            };
            

        // コンテンツ編集
        case SlideEvent.EditSlideStarted:
            return {
                ...state,
                isLoading: true,
                isEditSlide: true,
                isSuccessEditSlide: false,
                isFailedEditSlide: false,
                slide: undefined,
            };

        case SlideEvent.EditSlideComplete:
            return {
                ...state,
                slide: action.updateSlide,
                isLoading: false,
                isEditSlide: false,
                isSuccessEditSlide: true,
                isFailedEditSlide: false,
            };

        case SlideEvent.EditSlideFailed:
            return {
                ...state,
                isLoading: false,
                isEditSlide: false,
                isSuccessEditSlide: false,
                isFailedEditSlide: true,
            };

        // コンテンツ情報リセット
        case SlideEvent.ResetSlideInfo:
            return {
                ...state,
                slidePageCount: 0,
                slidePreviewImageUrl: [],
                slide: undefined,
                isLoading: false,
                isDeleteSlide: false,
                isSuccessDeleteSlide: false,
                isFailedDeleteSlide: false,
            };

        // コンテンツの削除
        case SlideEvent.DeleteSlideStarted:
            return {
                ...state,
                isLoading: true,
                isDeleteSlide: true,
                isSuccessDeleteSlide: false,
                isFailedDeleteSlide: false,
            };

        case SlideEvent.DeleteSlideComplete:
            return {
                ...state,
                isLoading: false,
                isDeleteSlide: false,
                isSuccessDeleteSlide: true,
                isFailedDeleteSlide: false,
            };

        case SlideEvent.DeleteSlideFailed:
            return {
                ...state,
                isLoading: false,
                isDeleteSlide: false,
                isSuccessDeleteSlide: false,
                isFailedDeleteSlide: true,
            };

        default:
            return state;
    }
}

export default slide;
